import React from 'react';
import PageHeader from './PageHeader';
import Best_1 from '../img/nominations/nominations_1.png';
import Best_2 from '../img/nominations/nominations_2.png';
import Best_3 from '../img/nominations/nominations_3.png';
import Best_4 from '../img/nominations/nominations_4.png';
import Best_5 from '../img/nominations/nominations_5.png';
import Best_6 from '../img/nominations/nominations_6.png';
import Best_7 from '../img/nominations/nominations_7.png';
import Best_8 from '../img/nominations/nominations_8.png';
import Best_9 from '../img/nominations/nominations_9.png';
import Best_10 from '../img/nominations/nominations_10.png';
import Best_11 from '../img/nominations/nominations_11.png';


const nominationsData = [
    {
      title: 'Лучший международный фильм',
      criteria: [
        'Художественная ценность: Фильм должен демонстрировать высокий уровень художественного исполнения, оригинальность сюжета и уникальность подачи материала.',
        'Культурное разнообразие: Оценка вклада фильма в представление культурных традиций и ценностей разных стран.',
        'Глобальный охват: Фильм должен иметь международное признание или сильный отклик у аудитории и критиков в разных странах.',
        'Техническое исполнение: Высокое качество режиссуры, операторской работы, монтажа, звукового оформления и визуальных эффектов.',
        'Эмоциональное воздействие: Насколько фильм способен вызвать у зрителей сильные эмоции и оставить длительное впечатление.',
      ],
      icon: Best_1,
    },
    {
      title: 'Лучший дебютный фильм',
      criteria: [
        'Оригинальность: Дебютный фильм должен демонстрировать уникальный стиль и новаторский подход режиссера.',
        'Художественное исполнение: Оценка качества исполнения всех элементов фильма, включая актёрскую игру, сценарий, операторскую работу и монтаж.',
        'Эмоциональная глубина: Способность фильма вызывать глубокие чувства у зрителей и передавать сложные эмоциональные состояния.',
        'Творческий потенциал: Оценка того, насколько дебютный фильм демонстрирует перспективы режиссера и команды.',
        'Новаторство: Уровень инноваций и экспериментов в создании фильма, который поднимает новые темы и предлагает свежие решения.',
      ],
      icon: Best_2,
    },
    {
      title: 'Лучший актер',
      criteria: [
        'Глубина образа: Насколько глубоко актер смог воплотить своего персонажа, передать его эмоциональные переживания и внутренний мир.',
        'Выразительность: Способность актера использовать голос, мимику, жесты и интонации для создания убедительного образа.',
        'Сложность роли: Оценка сложности исполненной роли с эмоциональной и физической точек зрения.',
        'Химия с партнерами по сцене: Насколько гармонично актер взаимодействует с другими актерами, создавая правдоподобные отношения на экране.',
        'Эмоциональное воздействие: Оценка того, насколько актерская игра способна вызывать у зрителей сопереживание и эмоциональный отклик.',
      ],
      icon: Best_3,
    },
    {
      title: 'Лучшая актриса',
      criteria: [
        'Эмоциональная глубина: Способность актрисы передать сложные эмоциональные состояния и нюансы своего персонажа.',
        'Мастерство перевоплощения: Уровень мастерства актрисы в перевоплощении, в том числе через изменения во внешнем облике, голосе и манерах.',
        'Сложность роли: Оценка сложности роли с точки зрения эмоциональной и физической отдачи.',
        'Взаимодействие с партнерами по сцене: Насколько органично и естественно актриса взаимодействует с другими актерами на экране.',
        'Влияние на зрителя: Способность актрисы вызвать сильные эмоции и заставить зрителя переживать за её героиню.',
      ],
      icon: Best_4,
    },
    {
      title: 'Лучший телевизионный проект',
      criteria: [
        'Оригинальность: Насколько уникален формат или сюжет проекта, что выделяет его среди других телевизионных программ.',
        'Качество исполнения: Оценка качества актерской игры, режиссуры, сценария, операторской работы и других элементов проекта.',
        'Популярность у зрителей: Влияние телевизионного проекта на аудиторию, его рейтинги и зрительские отклики.',
        'Тематическое разнообразие: Насколько проект охватывает актуальные и значимые для общества темы.',
        'Влияние на индустрию: Способность проекта оказать влияние на развитие телевизионной индустрии или создать новые тренды.',
      ],
      icon: Best_5,
    },
    {
      title: 'Лучший сериал',
      criteria: [
        'Сюжет и развитие персонажей: Оценка глубины и оригинальности сюжета, а также динамики развития персонажей на протяжении всего сериала.',
        'Качество исполнения: Высокий уровень режиссуры, сценария, актерской игры, монтажа и других аспектов создания сериала.',
        'Популярность и признание: Насколько сериал получил признание у аудитории и критиков, его рейтинги и культурное влияние.',
        'Долговечность: Оценка того, как сериал удерживает внимание зрителей и развивается на протяжении нескольких сезонов.',
        'Новаторство: Введение новых идей, тем или форматов, которые выводят индустрию на новый уровень.',
      ],
      icon: Best_6,
    },
    {
      title: 'Лучший сценарист',
      criteria: [
        'Оригинальность сценария: Насколько уникален и креативен сюжет, его структура и развитие событий.',
        'Глубина персонажей: Оценка глубины проработки персонажей, их мотиваций, внутреннего мира и отношений друг с другом.',
        'Диалоги: Качество написанных диалогов, их естественность и соответствие характеру персонажей.',
        'Тематика и социальная значимость: Насколько сценарий отражает актуальные проблемы общества или поднимает важные философские или моральные вопросы.',
        'Эмоциональное воздействие: Оценка того, насколько сценарий способен увлечь зрителя и вызвать у него сильные эмоции.',
      ],
      icon: Best_7,
    },
    {
      title: 'Лучший режиссер',
      criteria: [
        'Координация всех аспектов фильма: Способность режиссера гармонично объединить все элементы кинопроизводства (актерская игра, сценарий, операторская работа, монтаж и т.д.) в единое произведение искусства.',
        'Творческое видение: Уникальность и оригинальность режиссерского подхода к рассказу истории, включая интерпретацию сценария и работу с актерами.',
        'Управление командой: Эффективное руководство съемочной группой, умение вдохновлять актеров и технический персонал на максимальную отдачу.',
        'Стиль и атмосфера: Способность создавать уникальную визуальную и эмоциональную атмосферу, которая соответствует теме и духу фильма.',
        'Влияние на зрителей: Оценка того, насколько режиссерская работа способна воздействовать на зрителя, вызывать сильные эмоции и оставлять долгосрочное впечатление.',
      ],
      icon: Best_8,
    },
    {
      title: 'Лучший художник по свету',
      criteria: [
        'Художественное видение: Уникальность светового оформления, соответствие тематике и стилю проекта.',
        'Мастерство светового дизайна: Гармоничное использование света и тени, цветовых палитр и динамических переходов.',
        'Эмоциональное воздействие: Способность передавать эмоции через свет, усиливать драматизм и вовлекать зрителей.',
        'Инновации и креативность: Использование современных технологий и новаторских решений в световом дизайне.',
        'Синергия с визуальным стилем: Гармоничное сочетание света с декорациями, костюмами и операторской работой.',
        'Техническое мастерство: Профессионализм в управлении световым оборудованием и точная реализация световых схем.',
        'Влияние на зрительское восприятие: Способность усиливать восприятие сюжета и создавать запоминающуюся атмосферу.',
      ],
      icon: Best_11,
    },
    {
      title: 'Лучший композитор',
      criteria: [
        'Музыкальная тема: Оригинальность и запоминаемость музыкальных тем, которые усиливают атмосферу и эмоциональное восприятие фильма или сериала.',
        'Сочетание с сюжетом: Насколько музыка поддерживает и дополняет сюжет, усиливает драматические моменты и развивает настроение.',
        'Оригинальность и новаторство: Уникальность музыкальных решений, использование оригинальных инструментов или техник.',
        'Эмоциональное воздействие: Способность музыки вызывать у зрителя сильные эмоции и создавать особую атмосферу.',
        'Качество исполнения: Высокий уровень исполнения и записи музыки, её органичное вплетение в общее звуковое оформление фильма или сериала.',
      ],
      icon: Best_9,
    },
    {
      title: 'Лучший продюсер',
      criteria: [
        'Общий вклад в проект: Оценка роли продюсера в создании и реализации проекта, его ключевые решения и влияние на успешность фильма или сериала.',
        'Управление финансами и ресурсами: Способность продюсера эффективно управлять бюджетом, находить финансирование и организовывать процесс производства.',
        'Выбор и привлечение талантов: Успех продюсера в подборе ключевых членов команды (режиссер, сценарист, актеры) и способности объединить талантливых специалистов для работы над проектом.',
        'Коммерческий успех: Влияние продюсера на коммерческий успех фильма или сериала, включая прокатные сборы, продажи прав и другие финансовые показатели.',
        'Креативное руководство: Вклад продюсера в творческую концепцию проекта, его способность поддерживать режиссерское видение и развивать сценарий.',
      ],
      icon: Best_10,
    }
  ];

const Nominations = () => {
  return (
    <>
    <PageHeader title="Номинации" breadcrumb="Номинации" />
    <section className="nominations-section">
      <h2 className='title'>Номинации и Критерии отбора победителей Международной Премии в области кино и телевидения  Silver Phoenix Awards</h2>
      <div className="nominations-grid">
        {nominationsData.map((nomination, index) => (
          <div key={index} className="nomination-card">
            <img src={nomination.icon} alt={nomination.title} className="nomination-icon" />
            <h3 className="nomination-title">{nomination.title}</h3>
            <ul className="criteria-list">
              {nomination.criteria.map((criterion, i) => (
                <li key={i} className="criteria-item">{criterion}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
    </>
  );
};

export default Nominations;
